import CmsLink from "@/helpers/cms/CmsLink.js";
import CmsComponent from "@/helpers/editor/components/CmsComponent.js";
import ReviewStatus from "@/helpers/review/ReviewStatus.js";
import store from "@/store.js";

export default class CmsComponentButton extends CmsComponent {
    get allowBinding() {
        return true;
    }
    get allowMediaQuery() {
        return true;
    }
    get contentFields() {
        return [`link`, `text`, `newText`];
    }
    get translationFields() {
        return [`text`];
    }

    type = `button`

    constructor(data) {
        super(data);

        this.link = new CmsLink(this.link);

        if (!data) {
            this.size = `md`;
            this.buttonType = `solid`;
            this.borderRadius = `var(--border-radius)`;

            this.leftIcon = null;
            this.rightIcon = null;
            this.fillWidth = false;
            this.iconOnly = false;

            this.text = {};

            // Item Binding
            this.textField = null;
            this.linkField = null;
        }
        if (!this.variant) {
            this.variant = `primary`;
        }

        this.newText = this.text;
    }

    // do not init in constructor because cmsWebsite is not ready yet
    initText(text = { en: ``, fr: `` }, preset = `default`) {
        this.text = store.state.website.makeI18nText(text);
        this.newText = text;
        this.preset = preset;
    }

    getText(lang) {
        return this.text[lang];
    }

    applyChanges(language) {
        this.text = this.newText;
    }

    updateReview() {
        this.review = [];
        if (!this.link.isValid()) {
            this.review.push(new ReviewStatus(`error`, this, `Missing Button Link`));
        }
        return this.review;
    }
}
